import React from 'react'
import { connect } from 'react-redux'

export const CMSEmailTemplates = (props) => {
  return (
    <div>CMSEmailTemplates</div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CMSEmailTemplates)